import { SidebarMenuItem } from './SidebarMenuItem';
import {
    MdPeople,
    MdEmojiEvents,
    MdWorkspacePremium,
    MdInventory,
    MdVerifiedUser,
    MdEvent,
    MdQuiz,
    MdLightbulb,
    MdEco,
    MdSchool,
    MdPermMedia,
    MdEmail,
    MdCampaign,
    MdLocalOffer,
    MdRequestQuote,
    MdHome,
    MdReviews,
    MdInfo,
    MdNotificationsNone,
} from 'react-icons/md';

import { LuLayoutDashboard } from 'react-icons/lu';
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { IoNewspaperOutline } from "react-icons/io5";
import { RiAdvertisementLine } from "react-icons/ri";
import { RiBox3Fill } from "react-icons/ri";
import { MdOutlineAppSettingsAlt, MdHelpOutline } from "react-icons/md";
import { getAdminType } from '../../utils/adminType';

export default function SidebarMenu({ activeItem, setActiveItem, selectedTab, setSelectedTab, collapsed = false, onToggle }) {

    const adminType = getAdminType();
    
    const menuItems = [
        {
            id: 'dashboard',
            title: 'Dashboard',
            url: '/dashboard',
            icon: LuLayoutDashboard,
            section: 'Dashboard & Overview'
        },
        {
            id: 'page-organizer',
            title: 'Page Organizer',
            url: '/page-organizer',
            icon: MdHome,
            section: 'Dashboard & Overview',
            subItems: [
                {
                    id: 'homepage-organizer',
                    label: 'Home Page Organizer',
                    url: '/homepage-organizer',
                    // icon: MdHome,
                    // section: 'Dashboard & Overview'
                },
                {
                    id: 'challenge-homepage-organizer',
                    label: 'Challenge Home Page Organizer',
                    url: '/challenge-homepage-organizer',
                    // icon: GoGoal,
                    // section: 'Dashboard & Overview'
                },
                {
                    id: 'rewards-homepage-organizer',
                    label: 'Rewards Home Page Organizer',
                    url: '/rewards-homepage-organizer',
                    // icon: MdWorkspacePremium,
                    // section: 'Dashboard & Overview'
                },
            ]
        },
        {
            id: 'app-configs',
            title: 'App Configs',
            url: '/app-configs',
            icon: MdOutlineAppSettingsAlt,
            section: 'Dashboard & Overview',
            subItems: [
                {
                    id: 'app-configs',
                    label: 'App Configs',
                    url: '/configs',
                    // icon: MdOutlineAppSettingsAlt,
                    // section: 'Dashboard & Overview'
                },
                {
                    id: 'app-info',
                    label: 'App Info',
                    url: '/info',
                    // icon: MdInfo,
                    // section: 'Dashboard & Overview'
                },
            ]
        },
        {
            id: 'user',
            title: 'User',
            url: '/user',
            icon: MdPeople,
            section: 'User Management',
            subItems: [
                {
                    id: 'list', label: 'User List', url: '/list', subItems: [
                        // { id: 'all-users', label: 'All Users', url: '/all-users' },
                        { id: 'app-users', label: 'App Users', url: '/app-users' },
                        { id: 'ambassadors', label: 'Ambassadors', url: '/ambassadors' },
                        { id: 'ngos', label: 'NGOs', url: '/ngos' },
                        { id: 'companies', label: 'Companies', url: '/companies' },
                    ]
                },
                {
                    id: 'create-users', label: 'Create Users', url: '/create', subItems: [
                        // { id: 'user', label: 'User', url: '/user' },
                        { id: 'green-ambassador', label: 'Green Ambassador', url: '/ambassador' },
                        { id: 'ngo', label: 'NGO', url: '/ngo' },
                        { id: 'company', label: 'Company', url: '/company' }
                    ]
                },
                { id: 'users-delete-list', label: 'Users Deletion List', url: '/delete-list' },
                // { id: 'users-points-allocation-log', label: 'Points Allocation Log', url: '/point-allocation-log' },
            ]
        },
        {
            id: 'user-reviews',
            title: 'User Reviews',
            url: '/user-reviews',
            icon: MdReviews,
            section: 'User Management'
        },
        {
            id: 'admins',
            title: 'Admins',
            url: '/admins',
            icon: MdReviews,
            section: 'User Management',
            superAdminShow: true,
            subItems: [
                {
                    id: 'list-admins', label: 'Admin List', url: '/list-admins', superAdminShow: true,
                }
            ]
        },
        {
            id: 'challenges',
            url: '/challenges',
            title: 'Challenges',
            icon: MdEmojiEvents,
            section: 'Content Management',
            subItems: [
                {
                    id: 'challenge-categories', label: 'Challenges Categories', url: '/challenge-categories', subItems: [
                        { id: 'create-categories', url: '/create-categories', label: 'Create Challenge Categories' },
                        { id: 'view-categories', url: '/view-categories', label: 'View Category List' }
                    ]
                },
                {
                    id: 'challenges-main', url: '/challenges-main', label: 'Challenges', subItems: [
                        { id: 'create-challenge', url: '/create-challenge', label: 'Create Challenge' },
                        { id: 'view-challenges', url: '/view-challenges', label: 'View Challenge List' }
                    ]
                },
                // {
                //     id: 'proposed-challenges', url: '/proposed-challenges', label: 'Proposed Challenges'
                // }
            ]
        },
        {
            id: 'badge',
            url: '/badge',
            title: 'Badge',
            icon: MdWorkspacePremium,
            section: 'Content Management',
            subItems: [
                {
                    id: 'badge-categories', label: 'Badge Categories', url: '/badge-categories', subItems: [
                        { id: 'create-categories', url: '/create-categories', label: 'Create Badge Categories' },
                        { id: 'view-categories', url: '/view-categories', label: 'View Badge Category List' }
                    ]
                },
                {
                    id: 'badge-main', url: '/badge-main', label: 'Badges', subItems: [
                        { id: 'create-badge', url: '/create-badge', label: 'Create Badge' },
                        { id: 'view-badges', url: '/view-badges', label: 'View Badge List' },
                        { id: 'assign-badge', url: '/assign-badge', label: 'Assign Badge' }
                    ]
                },
            ]
        },
        {
            id: 'products',
            url: '/products',
            title: 'Products/Services',
            icon: MdInventory,
            section: 'Business & Partnerships',
            subItems: [
                {
                    id: 'product-categories', url: '/product-categories', label: 'Products/Services Categories', subItems: [
                        { id: 'create-product-categories', url: '/create-product-categories', label: 'Create Product/Services Categories' },
                        { id: 'view-product-categories', url: '/view-product-categories', label: 'View Category List' }
                    ]
                },
                {
                    id: 'products-main', url: '/products-main', label: 'Products/Services', subItems: [
                        { id: 'create-products', url: '/create-products', label: 'Create Products/Services' },
                        { id: 'view-products', url: '/view-products', label: 'View Products/Services List' }
                    ]
                }
            ]
        },
        {
            id: 'events',
            url: '/events',
            title: 'Events',
            icon: MdEvent,
            section: 'Content Management',
            subItems: [
                {
                    id: 'event-categories', label: 'Event Categories', url: '/event-categories', subItems: [
                        { id: 'create-categories', url: '/create-categories', label: 'Create Event Category' },
                        { id: 'view-categories', url: '/view-categories', label: 'Event Category List' }
                    ]
                },
                {
                    id: 'event-main', url: '/events-main', label: 'Events', subItems: [
                        { id: 'create-event', url: '/create-event', label: 'Create Event' },
                        { id: 'view-events', url: '/view-events', label: 'View Events List' }
                    ]
                },
                // {
                //     id: 'event-submissions', url: '/events-submissions', label: 'Event Submissions'
                // },
            ]
        },
        {
            id: 'blogs',
            url: '/blogs',
            title: 'Blogs',
            icon: IoNewspaperOutline,
            section: 'Content Management',
            subItems: [
                {
                    id: 'create-blog',
                    label: 'Create New Blog',
                    url: '/create-blog',
                },
                {
                    id: 'blog-list-admin',
                    label: 'Blog List',
                    url: '/blog-list-admin',
                },
                // {
                //     id: 'blog-list-user',
                //     label: 'Blog List',
                //     url: '/blog-list-user',
                // },
            ]
        },
        {
            id: 'quiz',
            url: '/quiz',
            title: 'Quiz',
            icon: MdQuiz,
            section: 'Content Management',
            subItems: [
                {
                    id: 'create-quiz',
                    label: 'Create New Quiz',
                    url: '/create-quiz',
                },
                {
                    id: 'quiz-list',
                    label: 'Quiz List',
                    url: '/quiz-list',
                },
            ]
        },
        {
            id: 'facts-details',
            url: '/fact-details',
            title: 'Facts',
            icon: MdLightbulb,
            section: 'Content Management',
            subItems: [
                { id: 'create-fact', label: 'Create Fact', url: '/create-fact' },
                { id: 'list-facts', label: 'View Facts List', url: '/list-facts' },
                // {
                //     id: 'eco-activity',
                //     label: 'Eco Activity',
                //     url: '/eco-activity',
                //     subItems: [
                //         // { id: 'create-eco-activity', label: 'Create Eco Activity', url: '/create-eco-activity' },
                //         { id: 'list-eco-activity', label: 'View Eco Activity List', url: '/list-eco-activity' }
                //     ]
                // }
            ]
        },
        {
            id: 'eco-activity',
            title: 'Eco Activity',
            url: '/eco-activity',
            icon: MdEco,
            section: 'Content Management',
            subItems: [
                // { id: 'create-eco-activity', label: 'Create Eco Activity', url: '/create-eco-activity' },
                { id: 'list-eco-activity', label: 'View Eco Activity List', url: '/list-eco-activity' }
            ]
        },
        {
            id: 'knowledge-board',
            url: '/knowledge-board',
            title: 'Knowledge Board',
            icon: MdSchool,
            section: 'Content Management',
            subItems: [
                {
                    id: 'tips',
                    label: 'Tips',
                    url: '/tips',
                    subItems: [
                        { id: 'create-tips', label: 'Create Tips', url: '/create-tips' },
                        { id: 'list-tips', label: 'View tips List', url: '/list-tips' }
                    ]
                },
                {
                    id: 'videos',
                    label: 'Videos',
                    url: '/videos',
                    subItems: [
                        { id: 'create-videos', label: 'Create Video', url: '/create-videos' },
                        { id: 'list-videos', label: 'View videos List', url: '/list-videos' }
                    ]
                },
                {
                    id: 'news',
                    label: 'News',
                    url: '/news',
                    subItems: [
                        { id: 'create-news', label: 'Create News', url: '/create-news' },
                        { id: 'list-news', label: 'View news List', url: '/list-news' }
                    ]
                },
            ]
        },
        {
            id: 'submissions',
            title: 'Verifications',
            icon: MdVerifiedUser,
            section: 'Verification & Moderation',
            subItems: [
                {
                    id: 'challenge-submission',
                    url: '/submissions/challenge-submission',
                    label: 'Challenge Submission',
                },
                {
                    id: 'event-submissions', url: '/events/events-submissions', label: 'Event Submissions'
                },
                {
                    id: 'proposed-challenges', url: '/challenges/proposed-challenges', label: 'Proposed Challenges'
                },
                { id: 'users-points-allocation-log', label: 'Points Allocation Log', url: '/user/point-allocation-log' },
                { id: 'blog-list-user', label: 'Blog Submissions', url: '/blogs/blog-list-user' },
                { id: 'plantation-project', label: 'Plantation Project', url: '/projects/plantation-project' },
            ]
        },
        {
            id: 'help-desk',
            url: '/help-desk',
            title: 'Help Desk',
            icon: TfiHeadphoneAlt,
            section: 'Communication',
            subItems: [
                {
                    id: 'help-desk-issues',
                    url: '/issues',
                    label: 'Help Desk - Issue',
                },
                // {
                //     id: 'help-desk-user-chat',
                //     url: '/user-chat',
                //     label: 'Help Desk - User Chat',
                // },
                {
                    id: 'help-desk-issue-category',
                    url: '/issue-category',
                    label: 'Help Desk - Issue Category List ',
                },
                {
                    id: 'inquiries',
                    url: '/inquiries',
                    label: 'Inquiries List',
                }
            ]
        },
        {
            id: 'notifications',
            url: '/notifications',
            title: 'Notifications',
            icon: MdNotificationsNone,
            section: 'Communication',
            subItems: [
                {
                    id: 'notification-types',
                    url: '/notification-types',
                    label: 'Notification Types',
                    superAdminShow: true,
                    // subItems: [
                    //     {
                    //         id: 'notification-types',
                    //         url: '/notification-types',
                    //         label: 'Notification Types',
                    //     },
                    // ],
                },
                {
                    id: 'notifications-list',
                    url: '/notifications-list',
                    label: 'Notifications List',
                    // subItems: [
                    //     {
                    //         id: 'notification-list',
                    //         url: '/notification-list',
                    //         label: 'Notification List',
                    //     },
                    // ],
                },
                {
                    id: 'admin-notifications-list',
                    url: '/admin-notifications-list',
                    label: 'Admin Notifications List',
                    // subItems: [
                    //     {
                    //         id: 'notification-list',
                    //         url: '/notification-list',
                    //         label: 'Notification List',
                    //     },
                    // ],
                },
                {
                    id: 'notification-logs',
                    url: '/notification-logs',
                    label: 'Notification Logs',
                }
            ]
        },
        {
            id: 'campaign-management',
            url: '/campaign-management',
            title: 'Campaign Management',
            icon: MdCampaign,
            section: 'Business & Partnerships',
            subItems: [
                {
                    id: 'new-campaign',
                    url: '/new-campaign',
                    label: 'New Campaign',
                },
                {
                    id: 'list-campaign',
                    url: '/list-campaign',
                    label: 'List Campaign',
                },
                // {
                //     id: 'edit-campaign-view',
                //     url: '/edit-campaign-view',
                //     label: 'Edit Campaign View',
                // },
                // {
                //     id: 'challenge-sponsor',
                //     url: '/challenge-sponsor',
                //     label: 'Challenge Sponsor',
                // },
                // {
                //     id: 'blog-sponsor',
                //     url: '/blog-sponsor',
                //     label: 'Blog Sponsor',
                // },
                // {
                //     id: 'brand-promotion',
                //     url: '/brand-promotion',
                //     label: 'Brand Promotion',
                // },
                // {
                //     id: 'csr-nsg-donation',
                //     url: '/csr-nsg-donation',
                //     label: 'CSR/NSG Donation',
                // },
                // {
                //     id: 'advertisement',
                //     url: '/advertisement',
                //     label: 'Advertisement',
                // },
                // {
                //     id: 'ngo-plant-tree',
                //     url: '/ngo-plant-tree',
                //     label: 'NGO Plant Tree',
                // },
                // {
                //     id: 'link-ngo-event-promotion',
                //     url: '/link-ngo-event-promotion',
                //     label: 'Link NGO Event Promotion',
                // }
            ]
        },
        {
            id: 'coupons',
            url: '/coupons',
            title: 'Coupons',
            icon: MdLocalOffer,
            section: 'Business & Partnerships',
            subItems: [
                {
                    id: 'create-coupon',
                    url: '/create-coupon',
                    label: 'Create Coupon',
                },
                {
                    id: 'list-coupon',
                    url: '/list-coupon',
                    label: 'List Coupons',
                },
                {
                    id: 'user-coupons',
                    url: '/user-coupons',
                    label: 'User Coupons',
                },
            ]
        },
        {
            id: 'brands',
            url: '/brands',
            title: 'Brands',
            icon: RiBox3Fill,
            section: 'Business & Partnerships',
            subItems: [
                {
                    id: 'create-brand',
                    url: '/create-brand',
                    label: 'Create Brand',
                },
                {
                    id: 'list-brand',
                    url: '/list-brand',
                    label: 'List Brands',
                },
            ]
        },
        {
            id: 'projects',
            url: '/projects',
            title: 'Projects',
            icon: MdEco,
            section: 'Business & Partnerships',
            subItems: [
                {
                    id: 'create-project',
                    url: '/create-project',
                    label: 'Create Project',
                },
                {
                    id: 'list-projects',
                    url: '/list-projects',
                    label: 'List Projects',
                },
            ]
        },
        {
            id: 'requests',
            url: '/requests',
            title: 'Partner Requests',
            icon: MdRequestQuote,
            section: 'Business & Partnerships',
            subItems: [
                {
                    id: 'create-request',
                    url: '/create-request',
                    label: 'Creation Request',
                },
                {
                    id: 'modification-request',
                    url: '/modification-request',
                    label: 'Modification Request',
                },
                {
                    id: 'support-tickets',
                    url: '/support-tickets',
                    label: 'Support Tickets',
                },
                // {
                //     id: 'list-requests',
                //     url: '/list-requests',
                //     label: 'List Requests',
                // },
            ]
        },
        {
            id: 'advertisements',
            url: '/advertisements',
            title: 'Advertisements',
            icon: RiAdvertisementLine,
            section: 'Business & Partnerships',
            subItems: [
                {
                    id: 'ads-management',
                    url: '/ads-management',
                    label: 'Ads Management',
                    subItems: [
                        { id: 'create-ad', url: '/create-ad', label: 'Create Ad' },
                        { id: 'list-ads', url: '/list-ads', label: 'List Ads' }
                    ]
                },
                {
                    id: 'slots-management',
                    url: '/slots-management',
                    label: 'Slots Management',
                    subItems: [
                        { id: 'create-slot', url: '/create-slot', label: 'Create Slot' },
                        { id: 'list-slots', url: '/list-slots', label: 'List Slots' }
                    ]
                },
                {
                    id: 'slot-allocations',
                    url: '/slot-allocations',
                    label: 'Slot Allocations',
                },
            ]
        },
        {
            id: 'media-library',
            url: '/media-library',
            title: 'Media Library',
            icon: MdPermMedia,
            section: 'Media & Resources',
            // subItems: [
            //     {
            //         id: 'dashboard',
            //         url: '/dashboard',
            //         label: 'Dashboard',
            //     },
            // ]
        },
        {
            id: 'document-repository',
            url: '/document-repository',
            title: 'Document Repository',
            icon: MdPermMedia,
            section: 'Media & Resources',
            subItems: [
                {
                    id: 'document-types',
                    url: '/document-types',
                    label: 'Document Types',
                },
                {
                    id: 'document-list',
                    url: '/document-list',
                    label: 'Document List',
                },
            ]
        },
        {
            id: 'user-guide',
            url: '/user-guide',
            title: 'User Guide',
            icon: MdHelpOutline,
            section: 'Help',
        },
    ];

    // Filter menu items based on admin type
    const filteredMenuItems = menuItems.map(item => {
        // If item has subItems, filter them too
        if(item.superAdminShow) {
            if(adminType !== 'superadmin') {
                return null; // Exclude this item for non-superadmin
            }
        }
        if (item.subItems) {
            const filteredSubItems = item.subItems.filter(subItem => {
                // If subItem has superAdminShow field, only show it for superadmin
                if (subItem.superAdminShow) {
                    return adminType === 'superadmin';
                }
                return true;
            }).map(subItem => {
                // If subItem has nested subItems, filter them too
                if (subItem.subItems) {
                    const filteredNestedSubItems = subItem.subItems.filter(nestedSubItem => {
                        if (nestedSubItem.superAdminShow) {
                            return adminType === 'superadmin';
                        }
                        return true;
                    });
                    return { ...subItem, subItems: filteredNestedSubItems };
                }
                return subItem;
            });
            
            return { ...item, subItems: filteredSubItems };
        }
        
        // For items without subItems, check superAdminShow directly
        if (item.superAdminShow) {
            return adminType === 'superadmin' ? item : null;
        }
        
        return item;
    }).filter(item => item !== null); // Remove null items

    // Group menu items by section
    const groupedMenuItems = filteredMenuItems.reduce((acc, item) => {
        const section = item.section || 'Other';
        if (!acc[section]) {
            acc[section] = [];
        }
        acc[section].push(item);
        return acc;
    }, {});

    // Define section order
    const sectionOrder = [
        'Dashboard & Overview',
        'User Management',
        'Content Management',
        'Verification & Moderation',
        'Communication',
        'Business & Partnerships',
        'Media & Resources',
        'Help',
        'Other'
    ];

    return (
        <>
        <nav
            className={`flex fixed z-50 overflow-y-auto overflow-x-hidden h-full no-scrollbar flex-col p-3 -mt-16 bg-white fill-white shadow-[0px_0px_25px_rgba(94,92,154,0.1)] min-h-screen max-md:pb-24 max-md:mt-0 transition-all duration-300 ease-in-out ${collapsed ? 'w-[72px] min-w-[72px] items-center' : 'w-[260px] min-w-64'}`}
        >
            {/* Logo + brand (text hidden when collapsed, image constrained to square so it doesn't squish) */}
            <div className={`flex items-center justify-center z-10 text-lg font-black text-primary max-md:px-5`}>
                <img
                    src={require('../../utils/media/logo.png')}
                    alt="climate crusaders"
                    className={collapsed ? 'h-10 w-10 object-contain shrink-0' : 'h-10 object-contain shrink-0'}
                />
                {!collapsed && <h1 className='text-primary font-extrabold text-lg ml-1'>Climate Crusaders</h1>}
            </div>

            <div className={`flex flex-col self-center mt-3 max-w-full text-sm ${collapsed ? 'w-full items-center' : 'w-[228px]'}`}>
                {sectionOrder.map((sectionName, sectionIndex) => {
                    const sectionItems = groupedMenuItems[sectionName];
                    if (!sectionItems || sectionItems.length === 0) return null;

                    return (
                        <div key={sectionName} className={collapsed ? 'w-full flex flex-col items-center' : ''}>
                            {/* Section Divider - Add HR before each section except the first one */}
                            {sectionIndex > 0 && (
                                <hr className={`my-4 border-secondary border-t-1 ${collapsed ? 'w-8' : ''}`} />
                            )}

                            {/* Section Header — hidden when collapsed */}
                            {!collapsed && (
                                <div className="mb-3 mt-4">
                                    <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-2">
                                        {sectionName}
                                    </h3>
                                </div>
                            )}

                            {/* Section Menu Items */}
                            {sectionItems.map((item) => {
                                // if (userState.viewAllTabs === true || userState.viewAllTabs === 'true') {
                                return (
                                    <SidebarMenuItem
                                        key={item.id}
                                        item={item}
                                        isActive={activeItem === item.id}
                                        onSelect={(id) => setActiveItem(id)}
                                        selectedTab={selectedTab}
                                        setSelectedTab={setSelectedTab}
                                        collapsed={collapsed}
                                        onRequestExpand={onToggle}
                                    />
                                );
                                // }
                                // else if (item.url) {
                                //     return (
                                //         <SidebarMenuItem
                                //             key={item.id}
                                //             item={item}
                                //             isActive={activeItem === item.id}
                                //             onSelect={(id) => setActiveItem(id)}
                                //             selectedTab={selectedTab}
                                //             setSelectedTab={setSelectedTab}
                                //         />
                                //     );
                                // }
                                // return null;
                            })}
                        </div>
                    );
                })}
                {/* <button
                    onClick={handleLogout}
                    className={`flex gap-1.5 px-3 py-2 mt-4 bg-navBtn rounded-md font-semibold text-black bg-opacity-10 text-gray-900`}
                >
                    <span className="grow shrink my-auto text-left font-extrabold text-base">Logout</span>
                </button> */}
            </div>
        </nav>

        {/* Collapse toggle — rendered OUTSIDE the nav so the nav's overflow doesn't
            clip it. position:fixed keeps it viewport-anchored; left tracks the
            sidebar width so it always sits on the sidebar's right edge. */}
        {onToggle && (
            <button
                onClick={onToggle}
                title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                className="fixed flex items-center justify-center w-7 h-7 rounded-full bg-white border border-border shadow-md text-primary hover:bg-primaryBgLight max-md:hidden"
                style={{
                    top: '88px',
                    left: collapsed ? '58px' : '246px',
                    zIndex: 60,
                    transition: 'left 300ms ease-in-out, background-color 200ms',
                }}
            >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}>
                    <path d="M7.5 2.5L3.5 6L7.5 9.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>
        )}
        </>
    );
}